export const STRIPE_CONFIG = {
  publishableKey: 'pk_live_51PJk9NP3jprYVV5DIX1FjwRc9xqWjZN8QtEbz3KnvOhMYpjR2Q5uqEIXtMxsvsqpNDqRsKvv45ksKzPm3TC2qoAn0012rfNWUA',

  paymentLinkUrl: 'https://buy.stripe.com/3cIeVf7Id12h4lKarGabK02',

  discountedPaymentLinkUrl: 'https://buy.stripe.com/6oU7sNgeJ12h5pO1VaabK03',

  originalPrice: 150,
  discountedPrice: 10,
};
 